module.exports = __webpack_public_path__ + "img/IMG_6726_L_BlackMatted_MockedUp.14a59af1.jpg";